export enum RegionalCommitteeSort {
    County = 1,
    Name,
    Status,
    DateFrom,
}